import { forwardRef } from 'react';

import s from './Fieldset.module.scss';
import { FieldsetProps, FieldsetProvider } from './context';

const Fieldset = forwardRef<HTMLDivElement, FieldsetProps>(({ isInvalid = false, isOptional = false, isRequired = false, ...rest }, ref) => {
  return (
    <FieldsetProvider value={{ isInvalid, isRequired, isOptional }}>
      <div className={s.fieldset} ref={ref} {...rest} />
    </FieldsetProvider>
  );
});
Fieldset.displayName = 'Fieldset';

export default Fieldset;
